import {
  createContext,
  ReactNode,
  ReactNodeArray,
  useContext,
  useMemo,
} from "react"

import { ChangedPlanRecord } from "./types"
import { CreatedTreeState } from "components/TreeState/types"
import { bookingItemsState as bks } from "./state"
import { crPlanItemsState as crs } from "./state"
import { flowPlanItemsState as fps } from "./state"
import { revBookingItemsState as rks } from "./state"

const context = createContext<CreatedTreeState<ChangedPlanRecord> | undefined>(
  undefined,
)

export function TableSourceProvider(props: {
  cr: boolean
  children: ReactNode | ReactNodeArray
  booking?: boolean
  rev?: boolean
}) {
  const value = useMemo(() => {
    if (props.cr) return crs
    if (props.rev) return rks
    if (props.booking) return bks

    return fps
  }, [props.cr, props.rev, props.booking])

  return <context.Provider value={value}>{props.children}</context.Provider>
}

export function useTableSource(): CreatedTreeState<ChangedPlanRecord> {
  const ctx = useContext(context)
  if (ctx === undefined) {
    throw new Error("useTableSource must be used inside TableSourceProvider!")
  }
  return ctx
}
